// @flow strict
import React from 'react';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import { withPrefix } from 'gatsby';
import type { Node as ReactNode } from 'react';
import { useSiteMetadata } from '../../hooks';
import styles from './Layout.module.scss';

type Props = {
  children: ReactNode,
  title: string,
  description?: string,
  socialImage? :string,
  fullWidth?: boolean,
  // Lets a page opt out of a site-wide choice — the archived landing page uses
  // it to keep the typeface the site used before the change.
  className?: string
};

const Layout = ({
  children,
  title,
  description,
  socialImage,
  fullWidth,
  className
}: Props) => {
  const { author, url } = useSiteMetadata();
  const metaImage = socialImage != null ? socialImage : author.photo;
  const metaImageUrl = url + withPrefix(metaImage);

  return (
    <div className={classNames(styles.layout, { [styles['layout--full']]: fullWidth }, className)}>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={metaImageUrl} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={metaImageUrl} />
      </Helmet>
      {children}
    </div>
  );
};

export default Layout;
